import React from 'react';
import cnames from 'classnames';
import { Slide } from '@redbubble/design-system/react/Carousel';
import styles from './LoadingSlides.css';

const LoadingSlides = ({
  numberOfItems,
  background,
  itemClass,
  slideClass
}) => {
  const items = [...Array(numberOfItems).keys()];
  const itemStyle =
    background === 'light' ? styles.loadingGridLight : styles.loadingGrid;

  return items.map(i => (
    <Slide key={i} className={slideClass}>
      <div className={cnames(itemStyle, itemClass)} />
    </Slide>
  ));
};

export default LoadingSlides;
